import { safeNumber } from "../lib/format";

export function ProgressBar(props: {
  used: number | null | undefined;
  cap: number | null | undefined;
  label: string;
  formatValue?: (n: number) => string;
}) {
  if (props.cap === null || props.cap === undefined) {
    return (
      <div className="muted" style={{ fontSize: 12, marginTop: 6 }}>
        {props.label}: unmetered
      </div>
    );
  }
  const used = safeNumber(props.used);
  const cap = props.cap;
  const pct = cap > 0 ? Math.min(100, Math.round((used / cap) * 100)) : 0;
  const fmt = props.formatValue ?? ((n: number) => n.toLocaleString());
  return (
    <div style={{ marginTop: 6 }}>
      <div
        style={{
          background: "var(--bg-input)",
          height: 6,
          borderRadius: 3,
          border: "1px solid var(--rule)"
        }}
      >
        <div
          style={{
            background: pct >= 100 ? "var(--failure)" : "var(--verified)",
            height: "100%",
            width: `${pct}%`,
            borderRadius: 3
          }}
        />
      </div>
      <div className="muted" style={{ fontSize: 12, marginTop: 4 }}>
        {props.label}: {pct}% ({fmt(used)} / {fmt(cap)})
      </div>
    </div>
  );
}
